
class MainAbout extends HTMLElement {
  constructor() {
    super()

    this.device = (window.innerWidth >= 750) ? 'desktop' : 'mobile'
    this.lazyLoadVideo()

    window.addEventListener('resize', () => {
      const device = (window.innerWidth >= 750) ? 'desktop' : 'mobile'
      if (device != this.device) {
        this.device = device
        this.lazyLoadVideo()
      }
    })
  }

  lazyLoadVideo () {
    let selector = '.js-video'

    document.querySelectorAll(selector).forEach(videoEl => {
      const lazySrc = videoEl.getAttribute('data-lazy-poster')

      videoEl.querySelectorAll('source').forEach(source => {
        const sourceSrc = source.getAttribute('data-src')
        if (sourceSrc) videoEl.setAttribute('src', sourceSrc)
      })

      if (lazySrc) {
        const src = lazySrc.replace('&width=1100', `&width=${videoEl.offsetWidth}`)
        videoEl.setAttribute('poster', src)
        videoEl.setAttribute('autoplay', '')
      }

      videoEl.play()
    })
  }
}

customElements.define('main-about', MainAbout)
